export enum InviteUsersModalEvent {
	Open = 'open-user-invite-modal',
	InvitationSent = 'invite-users-invitation-sent',
}
